<template>
  <div id="left-sidebar" class="sidebar">
    <div class="">
      <div class="user-account">
        <img
          :src="require('@/assets/Profile.jpg')"
          class="rounded-circle user-photo"
          style="height: 50px; width: 50px"
          alt="User Profile Picture"
        />
        <div
          class="dropdown"
          v-bind:class="{ show: dropActive }"
          @click="dropActive = !dropActive"
          v-click-outside="outside"
        >
          <span>Welcome,</span>
          <a
            href="javascript:void(0);"
            class="dropdown-toggle user-name"
            data-toggle="dropdown"
            :aria-expanded="dropActive ? 'true' : 'false'"
          >
            <strong>{{ username || "User" }}</strong>
          </a>

          <ul
            class="dropdown-menu dropdown-menu-right account"
            v-bind:class="{ show: dropActive }"
            :style="
              dropActive
                ? 'top: 100%; position: absolute; transform: translate3d(-52px, 42px, 0px); left: 0px; will-change: transform;'
                : 'top: 80%; position: absolute; transform: translate3d(-52px, 42px, 0px); left: 0px; will-change: transform;'
            "
          >
            <li>
              <router-link to="/pages/page-profile2"
                ><i class="icon-user"></i>My Profile</router-link
              >
            </li>
            <li>
              <a href="javascript:void(0);"
                ><i class="icon-settings"></i>Settings</a
              >
            </li>
            <li class="divider"></li>
            <li>
              <router-link to="/authentication/page-login"
                ><i class="icon-power"></i>Logout</router-link
              >
            </li>
          </ul>
        </div>
        <div></div>
      </div>
      <!-- Nav tabs -->
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a
            class="nav-link"
            v-on:click="setActiveNavtab('Menu')"
            :class="{ 'active show': openNavtab('Menu') }"
            data-toggle="tab"
            >Menu</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-on:click="setActiveNavtab('Setting')"
            :class="{ 'active show': openNavtab('Setting') }"
            data-toggle="tab"
            ><i class="icon-settings"></i
          ></a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            v-on:click="setActiveNavtab('Question')"
            :class="{ 'active show': openNavtab('Question') }"
            data-toggle="tab"
            ><i class="icon-question"></i
          ></a>
        </li>
      </ul>
      <!-- Tab panes -->
      <div class="tab-content p-l-0 p-r-0">
        <div
          class="tab-pane"
          :class="{ 'active show': openNavtab('Menu') }"
          id="menu"
        >
          <nav id="left-sidebar-nav" class="sidebar-nav">
            <ul id="main-menu" class="metismenu">
              <li :class="{ active: currentActiveMenu == 'dashboard' }">
                <router-link to="/dashboard">
                  <i class="icon-home"></i>
                  <span>Dashboard</span>
                </router-link>
              </li>

              <li :class="{ active: currentActiveMenu === 'subjects' }">
                <router-link to="/Subjects">
                  <i class="fa fa-medkit"></i>
                  <span>Subjects</span>
                </router-link>
              </li>
              <li :class="{ active: currentActiveMenu === 'ReportPage' }">
                <router-link to="/reportPage">
                  <i class="icon-docs"></i>
                  <span>Reports</span>
                </router-link>
              </li>
              <li :class="{ active: currentActiveMenu === 'charts' }">
                <a class="has-arrow" v-on:click="setActive('charts')"
                  ><i class="icon-bar-chart"></i> <span>Charts</span></a
                >
                <ul v-if="currentActiveMenu === 'charts'">
                  <li
                    v-bind:class="{
                      active: currentRoutePath == '/charts/chart-PFL',
                    }"
                  >
                    <router-link to="/charts/chart-PFL">PFL Charts</router-link>
                  </li>
                  <li
                    v-bind:class="{
                      active: currentRoutePath == '/charts/chart-growth',
                    }"
                  >
                    <router-link to="/charts/chart-growth"
                      >Growth Charts</router-link
                    >
                  </li>
                </ul>
              </li>
              <li
                :class="{ active: currentActiveMenu === 'ClinicalAssessment' }"
              >
                <a href="#" @click.prevent="openClinicalAssessment">
                  <i class="icon-docs"></i>
                  <span>Facial Assessment</span>
                </a>
              </li>
              <!--
                  
                        <li :class="{ 'active': currentActiveMenu === 'ui-elements'}">
                            <a class="has-arrow" v-on:click="setActive('ui-elements')"><i class="icon-diamond"></i> <span>UI Elements</span></a>
                            <ul v-if="currentActiveMenu === 'ui-elements'">
                                <li v-bind:class="{ 'active':currentRoutePath == '/ui-elements/ui-typography'}" ><router-link to="/ui-elements/ui-typography">Typography</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/ui-elements/ui-tabs'}" ><router-link to="/ui-elements/ui-tabs">Tabs</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/ui-elements/ui-buttons'}" ><router-link to="/ui-elements/ui-buttons">Buttons</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/ui-elements/ui-bootstrap'}" ><router-link to="/ui-elements/ui-bootstrap">Bootstrap UI</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/ui-elements/ui-icons'}" ><router-link to="/ui-elements/ui-icons">Icons</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/ui-elements/ui-notifications'}" ><router-link to="/ui-elements/ui-notifications">Notifications</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/ui-elements/ui-colors'}" ><router-link to="/ui-elements/ui-colors">Colors</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/ui-elements/ui-listgroup'}" ><router-link to="/ui-elements/ui-listgroup">List Group</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/ui-elements/ui-media'}" ><router-link to="/ui-elements/ui-media">Media Object</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/ui-elements/ui-modals'}" ><router-link to="/ui-elements/ui-modals">Modals</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/ui-elements/ui-progressbars'}" ><router-link to="/ui-elements/ui-progressbars">Progress Bars</router-link></li>                               
                            </ul>
                        </li>-->
              <!--
                        <li :class="{ 'active': currentActiveMenu === 'widgets'}">
                            <a  class="has-arrow" v-on:click="setActive('widgets')" ><i class="icon-puzzle"></i> <span>Widgets</span></a>
                            <ul v-if="currentActiveMenu === 'widgets'"> 
                                <li v-bind:class="{ 'active':currentRoutePath == '/widgets/widgets-data'}" ><router-link to="/widgets/widgets-data">Data</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/widgets/widgets-weather'}" ><router-link to="/widgets/widgets-weather">Weather</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/widgets/widgets-blog'}" ><router-link to="/widgets/widgets-blog">Blog</router-link></li>                                 
                                <li v-bind:class="{ 'active':currentRoutePath == '/widgets/widgets-ecommerce'}" ><router-link to="/widgets/widgets-ecommerce">eCommerce</router-link></li>                                 
                            </ul>
                        </li>
                        <li :class="{ 'active': currentActiveMenu === 'authentication'}">
                            <a  class="has-arrow" v-on:click="setActive('authentication')"><i class="icon-lock"></i> <span>Authentication</span></a>
                            <ul v-if="currentActiveMenu === 'authentication'">      
                                <li v-bind:class="{ 'active':currentRoutePath == '/authentication/page-login'}" ><router-link to="/authentication/page-login">Login</router-link></li>                                                            
                                <li v-bind:class="{ 'active':currentRoutePath == '/authentication/page-register'}" ><router-link to="/authentication/page-register">Register</router-link></li>   
                                <li v-bind:class="{ 'active':currentRoutePath == '/authentication/page-lockscreen'}" ><router-link to="/authentication/page-lockscreen">Lockscreen</router-link></li>                                                                                                                     
                                <li v-bind:class="{ 'active':currentRoutePath == '/authentication/page-forgot-password'}" ><router-link to="/authentication/page-forgot-password">Forgot Password</router-link></li>     
                                <li v-bind:class="{ 'active':currentRoutePath == '/authentication/page-404'}" ><router-link to="/authentication/page-404">Page 404</router-link></li>                                                                                                                     
                                <li v-bind:class="{ 'active':currentRoutePath == '/authentication/page-403'}" ><router-link to="/authentication/page-403">Page 403</router-link></li>                                                                                                                                         
                                <li v-bind:class="{ 'active':currentRoutePath == '/authentication/page-500'}" ><router-link to="/authentication/page-500">Page 500</router-link></li>                                                                                                                     
                                <li v-bind:class="{ 'active':currentRoutePath == '/authentication/page-503'}" ><router-link to="/authentication/page-503">Page 503</router-link></li>                                                                                                                     
                            </ul>
                        </li>
                   
                        <li :class="{ 'active': currentActiveMenu === 'forms'}">
                            <a class="has-arrow" v-on:click="setActive('forms')"><i class="icon-pencil"></i> <span>Forms</span></a>
                            <ul v-if="currentActiveMenu === 'forms'">    
                                <li v-bind:class="{ 'active':currentRoutePath == '/forms/forms-validation'}" ><router-link to="/forms/forms-validation">Form Validation</router-link></li>                                                                                                                     
                                <li v-bind:class="{ 'active':currentRoutePath == '/forms/forms-basic'}" ><router-link to="/forms/forms-basic">Basic Elements</router-link></li>                                                                                                                     
                            </ul>
                        </li>-->
            </ul>
          </nav>
        </div>

        <div
          class="tab-pane p-l-15 p-r-15"
          :class="{ 'active show': openNavtab('Setting') }"
          id="setting"
        >
          <h6>Choose Mode</h6>
          <ul class="choose-skin list-unstyled">
            <li
              data-theme="white"
              :class="{ active: data_theme === '' }"
              v-on:click="setactiveTheme('')"
            >
              <div class="white"></div>
              <span>Light</span>
            </li>
            <li
              data-theme="black"
              :class="{ active: data_theme === 'full-dark' }"
              v-on:click="setactiveTheme('full-dark')"
            >
              <div class="black"></div>
              <span>Dark</span>
            </li>
          </ul>
          <hr />
          <h6>Choose Skin</h6>
          <ul class="choose-skin list-unstyled">
            <li
              data-theme="purple"
              v-bind:class="{ active: activeColor === 'purple' }"
              v-on:click="changeBodycolor('purple')"
            >
              <div class="purple"></div>
              <span>Purple</span>
            </li>
            <li
              data-theme="blue"
              v-bind:class="{ active: activeColor === 'blue' }"
              v-on:click="changeBodycolor('blue')"
            >
              <div class="blue"></div>
              <span>Blue</span>
            </li>
            <li
              data-theme="cyan"
              v-bind:class="{ active: activeColor === 'cyan' }"
              v-on:click="changeBodycolor('cyan')"
            >
              <div class="cyan"></div>
              <span>Cyan</span>
            </li>
            <li
              data-theme="green"
              v-bind:class="{ active: activeColor === 'green' }"
              v-on:click="changeBodycolor('green')"
            >
              <div class="green"></div>
              <span>Green</span>
            </li>
            <li
              data-theme="orange"
              v-bind:class="{ active: activeColor === 'orange' }"
              v-on:click="changeBodycolor('orange')"
            >
              <div class="orange"></div>
              <span>Orange</span>
            </li>
          </ul>
          <hr />
        </div>
        <div
          class="tab-pane p-l-15 p-r-15"
          :class="{ 'active show': openNavtab('Question') }"
          id="question"
          style="height: 500px"
        >
          <form>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text"
                  ><i class="icon-magnifier"></i
                ></span>
              </div>
              <input type="text" class="form-control" placeholder="Search..." />
            </div>
          </form>
          <ul class="list-unstyled question">
            <li class="menu-heading">HOW-TO</li>
            <li><a href="javascript:void(0);">Create a Facescan</a></li>
            <li><a href="javascript:void(0);">Generate Reports</a></li>
            <li class="menu-heading">ACCOUNT</li>
            <li><a href="javascript:void(0);">Create New Account</a></li>
            <li><a href="javascript:void(0);">Change Password</a></li>
            <li><a href="javascript:void(0);">Privacy &amp; Policy</a></li>
          </ul>

          <div class="menu-button m-t-30">
            <button
              class="btn btn-primary mb-2"
              @click="showHelpPopup = !showHelpPopup"
            >
              <i class="icon-question mr-2"></i>Need Help?
            </button>

            <div v-if="showHelpPopup" class="sidebar-popup">
              For any inquiries or assistance, please contact:<br />
              <strong style="color: #384797"
                >michael.suttie@wrh.ox.ac.uk</strong
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SidebarComponent",
  methods: {
    async fetchUserDetails() {
      try {
        const fasdBackendURL =
          localStorage.getItem("fasdBackendURL") || "http://localhost:8000";

        const token = localStorage.getItem("userJWtoken");
        console.log("fasdBackendURL", fasdBackendURL);

        const response = await fetch(`${fasdBackendURL}/api/users/me`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`Failed to fetch user details: ${response.status}`);
        }

        const data = await response.json();
        this.username = data.username || "User";
      } catch (error) {
        console.error("Error fetching user details:", error);
      }
    },
    changeBodycolor(color) {
      this.activeColor = color;
      document.body.className = "theme-" + color + " " + this.data_theme;
    },

    outside: function () {
      this.dropActive = false;
    },

    setActive: function (menuItem) {
      if (this.currentActiveMenu === menuItem) {
        this.currentActiveMenu = null;
      } else {
        this.currentActiveMenu = menuItem;
      }
    },
    closeHelpPopup() {
      this.showHelpPopup = false;
    },
    async openClinicalAssessment() {
  try {
    const fasdBackendURL =
      localStorage.getItem("fasdBackendURL") ||
      "http://localhost:8000";

    const token =
      localStorage.getItem("userJWtoken");

    if (!token) {
      alert("Please log in first.");
      return;
    }

    const url =
      `${fasdBackendURL}/api/clinicalAssesment/access`;

    console.log("Clinical access URL:", url);
    console.log("Token exists:", !!token);

    const response = await fetch(url, {
      method: "GET",

      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    console.log(
      "Clinical access HTTP status:",
      response.status
    );

    let data = null;

    try {
      data = await response.json();
    } catch (error) {
      console.error(
        "Could not parse access response:",
        error
      );
    }

    console.log(
      "Clinical access response:",
      data
    );

    // ---------------------------------------------
    // Not logged in / token expired
    // ---------------------------------------------

    if (response.status === 401) {
      alert(
        "Your session has expired. Please log in again."
      );

      return;
    }

    // ---------------------------------------------
    // Logged in, but not approved
    // ---------------------------------------------

    if (response.status === 403) {
      alert(
        data?.detail ||
        "You do not have permission to access Facial Assessment."
      );

      return;
    }

    // ---------------------------------------------
    // Other backend problem
    // ---------------------------------------------

    if (!response.ok) {
      throw new Error(
        data?.detail ||
        `Access check failed with status ${response.status}`
      );
    }

    // ---------------------------------------------
    // Backend approved user
    // ---------------------------------------------

    if (data?.allowed === true) {
      console.log(
        "Clinical access granted to:",
        data.username
      );

      await this.$router.push(
        "/ClinicalAssessment"
      );

      return;
    }

    // Should normally never happen
    alert(
      "You do not have permission to access Facial Assessment."
    );

  } catch (error) {
    console.error(
      "Clinical Assessment access error:",
      error
    );

    alert(
      "Unable to verify Facial Assessment access."
    );
  }
},

    openNavtab: function (tab) {
      return this.currentMenuTab === tab;
    },
    setActiveNavtab: function (tab) {
      this.currentMenuTab = tab;
    },
    setactiveTheme: function (theme) {
      this.data_theme = theme;
      document.body.className = "theme-" + this.activeColor + " " + theme;
      this.emitter.emit("theme", theme);
    },
  },
  data() {
    return {
      username: "",
      currentActiveMenu: window.location.pathname.split("/")[2],
      currentMenuTab: "Menu",
      activeColor: "cyan",
      dropActive: "",
      data_theme: "",
      showHelpPopup: false,
    };
  },

  computed: {
    currentRoutePath() {
      return this.$route.path;
    },
  },
  mounted() {
    this.fetchUserDetails();
  },
  watch: {
    $route() {
      this.currentActiveMenu = window.location.pathname.split("/")[1];
      if (window.location.pathname.split("/")[2] == this.currentActiveMenu) {
        document.body.className =
          "theme-" + this.activeColor + " " + this.data_theme;
      }
    },
  },
};
</script>
<style scoped>
.help-popup {
  position: fixed;
  bottom: 30px;
  left: 30px;
  background: white;
  border: 1px solid #ccc;
  padding: 12px 16px;
  font-size: 13px;
  border-radius: 5px;
  z-index: 99999;
}
.sidebar-popup {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #3b3b4638;
  padding: 10px;
  z-index: 9999;
  width: 220px;
  box-sizing: border-box;
  font-size: 13px;
  border-radius: 4px;
}
.menu-button {
  position: relative;
}
</style>
